const value = Object.freeze({
  PendienteAnalisis: 1,
  PendienteDeterminacion: 2,
  Rechazado: 3,
  PendienteDeCita: 4,
  PendienteDeEvaluacion: 5,
  PendienteDeRecoordinarCita: 6,
  Ajustado: 7,
  PendienteDeDiscusion: 8,
  PendienteDeRequisicion: 9,
  PendienteDeCompra: 10,
  PendienteDeEntregaCSEE: 11,
  PendienteDeEntregaEscuela: 12,
  PendienteDeDiscusionEscuela: 13,
  Servido: 14,
  PendienteDeValidacion: 15, //Estatus para el tipo de Referido Validacion
  PendienteDeAvaluo: 16, //Estatus para el tipo de Referido Avalúo
  PendienteAnalisisRequisicion: 17,
  PendienteDeDocumentacion: 18,
  PendienteDeClasificacion: 21,
  PendienteDeServicio: 22,
  PendienteDeRequisicionDevueltoPorSIFDE: 23,
  PendienteDocumentarEvaluacion: 24,
});
export default value;
